$( document ).ready(function() {
  var postnewslater = window.location.search;
  if(postnewslater == '?customer_posted=true'){
    $('body').find('#NewsletterPopup-newsletter-popup .newsletter-popup__content .rte').remove();
    $('body').find('#NewsletterPopup-newsletter-popup .newsletter-popup__content .input-group.newsletter__input-group').remove();
}
  $('.grid-product__colors p').on('click',function(){
    $(this).parent().parent().find('.grid-product__secondary-image').remove();
    var getImg = $(this).attr('data-src');
    var getUrl = $(this).attr('data-href');
    $(this).parent().parent().find('a.grid-product__link .image-wrap').empty();
    $(this).parent().parent().find('a.grid-product__link .image-wrap').append("<img style='opacity:1' src='"+ getImg +"' />");
    $(this).parent().parent().find('a.grid-product__link').attr('href', getUrl);
    console.log('getImg', getImg);
  });

  $('.custom-special-promo-products-wrapper > .column > .product-item-wrapper > .product-item > .product-color-wrapper > .product-color-item')
    .on('click', function () {
      var getImg = $(this).attr('data-src'),
        getUrl = $(this).attr('data-href'),
        productImageWrapper = $(this).parent().parent().find('div.product-image-wrapper'),
        productImageSecondary = $(this).parent().parent().find('div.product-image-secondary'),
        productImageContent = $(this).parent().parent().find('a.product-item-content');
      productImageWrapper.empty();
      productImageSecondary.remove();
      productImageWrapper.append(
        $('<img>', {
          src: getImg,
          class: 'product-image'
        })
      );
      productImageContent.attr('href', getUrl);
    });
  
  // --
  // The code below commented because the "Additional charge" is not displayed in the zepto product personalization anymore as requested by Client,
  // uncomment if it needs to be displayed again
  // var data_original_price = 0;
  // $('body').on('click', '.product-personalizer button', function(){
  //   $('body').find('.pplr-modal-box .pplr-modal-body input').hide();
  //     setTimeout(function(){
  //       // var original_price = $('body').find('.pplr-modal-body span.pplrcur.pplr_cur.money').text();
  //       var original_price = $('#original-product-price').val();
  //       if(original_price == null || original_price == '') {
  //         setTimeout(function(){
  //           data_original_price = original_price;
  //           $('body').find('.pplr-modal-box .pplr-modal-body input').show();
  //         },1000);
  //       }else{
  //         data_original_price = original_price;
  //         $('body').find('.pplr-modal-box .pplr-modal-body input').show();
  //       }

  //       },1000);
  // });
  // $('body').on('change keyup keydown', '.pplr-modal-box .pplr-modal-body input', function(){
  //   setTimeout(function(){
  //   var OriginalPriceInt = data_original_price.replace(/\D/g,'');
  //   var NewPrice = $('body').find('.pplr-modal-body span.pplrcur.pplr_cur.money').text();
  //   console.log('NewPrice', NewPrice);
  //   var NewPriceInt = NewPrice.replace(/\D/g,'');

  //   var plusPrice = NewPriceInt - OriginalPriceInt;
    
  //   $('.pplr_ex_inner span.pplrcur.pplr_cur.money').html('<span>'+ data_original_price +'</span>');
  //   $('.pplr_ex_inner span.pplrcur.pplr_cur.money').append('<span> Additional: Rp '+ ReplaceNumberWithCommas(plusPrice) +'</span>');

    
  //   console.log('data_original_price', OriginalPriceInt);
  //     },1000);
  //   });
  // $('body').on('click', '.pplr-drop-item', function(){
  //   setTimeout(function(){
  //   var OriginalPriceInt = data_original_price.replace(/\D/g,'');
  //   var NewPrice = $('body').find('.pplr-modal-body span.pplrcur.pplr_cur.money').text();
  //   console.log('NewPrice', NewPrice);
  //   var NewPriceInt = NewPrice.replace(/\D/g,'');

  //   var plusPrice = NewPriceInt - OriginalPriceInt;
    
  //   $('.pplr_ex_inner span.pplrcur.pplr_cur.money').html('<span>'+ data_original_price +'</span>');
  //   $('.pplr_ex_inner span.pplrcur.pplr_cur.money').append('<span> Additional: Rp '+ ReplaceNumberWithCommas(plusPrice) +'</span>');

    
  //   console.log('data_original_price', plusPrice);
  //     },1000);
  //   });
  // --

function ReplaceNumberWithCommas(yourNumber) {
    //Seperates the components of the number
    var n= yourNumber.toString().split(".");
    //Comma-fies the first part
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //Combines the two sections
    return n.join(".");
}


  
    $('body').on('click', '.BundleID', function(){
      var get_bundle = $(this).attr('data-bundle');
      console.log('get_bundle', get_bundle);
      var arrayRemove = [];
      if(get_bundle.length > 0){
        $('.cart__item[data-bundle="'+ get_bundle +'"]').each(function( index ) {
             var getID = $(this).attr('data-key');
             arrayRemove.push( $(this).attr("data-key") );
            
        });
      }else{
        var dataID = $(this).attr('data-id');
        var dataKey = $('.cart__item[data-id="'+ dataID +'"]').attr('data-key');
        arrayRemove.push( dataKey );
      }

      console.log('arrayRemove', arrayRemove);
      
      removeItems(arrayRemove);
      
      
    });

    function removeItems(items) {
      var itemsProcessed = items;
      
      var itemsArray = items;
      var qty = 0;
      var data = { updates: {} };
     
      for (i = 0; i < itemsArray.length; i++) {
         data.updates[itemsArray[i]] = qty;
      }
    
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() { 
          location.reload();
        }
      });
    
     }
  
});